import { useState } from 'react';
import PropTypes from 'prop-types';
import { toAudString } from 'utils/currency';
import { Link } from 'components/UI/Link/Link';
import { RemoveMembershipPrompt } from './Prompts/RemoveMembershipPrompt';

export const Membership = (props) => {
  const { items, stepName } = props;

  const [membershipItem, setMembershipItem] = useState(null);

  const handleRequestPromptClose = () => {
    setMembershipItem(null);
  };

  const requestRemoveMembership = (lineItemId, description) => {
    setMembershipItem({
      lineItemId,
      description,
    });
  };

  return (
    <>
      <RemoveMembershipPrompt
        active={!!membershipItem}
        membership={membershipItem}
        onRequestClose={handleRequestPromptClose}
        stepName={stepName}
      />

      {items.map((item) => (
        <div key={item.LineItemId}>
          <table className="table-css-responsive table-fullwidth cart-table cart-table-payment">
            <thead>
              <tr>
                <th>Membership</th>
                <th className="cell-price">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr className="row-cart-addons">
                <td className="seat-info">{item.CartDescription}</td>
                <td className="addon-price seat-info">{toAudString(item.Amount)}</td>
              </tr>
              <tr>
                <td colSpan="2" className="seat-info cell-remove">
                  <Link
                    href="#"
                    onClick={() => {
                      requestRemoveMembership(item.LineItemId, item.CartDescription);
                    }}
                    extendClass="link-bold cart-remove"
                    variant="secondary"
                  >
                    Remove
                  </Link>
                </td>
              </tr>
            </tbody>
          </table>
          <hr className="hr-double" />
        </div>
      ))}
    </>
  );
};

Membership.propTypes = {
  items: PropTypes.array.isRequired,
  stepName: PropTypes.string,
};
